import 'reflect-metadata';
import {CommonModule} from '@angular/common';
import {ErrorHandler, NgModule} from '@angular/core';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {HTTP_INTERCEPTORS, HttpClientModule} from '@angular/common/http';
import {UIRouterModule} from '@uirouter/angular';
import {ComponentsModule} from '../components/components.module';
import {PipesModule} from 'app/pipes/pipes.module';
import {ToastrModule} from 'ngx-toastr';
// import { CarouselModule } from 'ngx-owl-carousel-o';

// Pages========================
import {
    DefaultMasterPageComponent,
    TravelsPageComponent,
    TravelProfileComponent,
    EventsPageComponent,
    MainPageComponent,
    ChatPageComponent,
    LoginPageComponent,
    ForgotPasswordPageComponent,
    ChangePasswordPageComponent,
    UserProfileComponent
} from './index';
import {AuthenticationInterceptor, ResponseInterceptor} from '../common';

// Services=========================
import {
    RoutingService,
    SettingsService,
    StorageService,
    AuthenticationService,
    TravelsService,
    EventsService,
    AppToastrService,
    UsersService,
    ClientsService,
    DictionaryService,
    DocumentsService,
    ChatService, WebsocketService
} from '../services';
import {InViewportModule} from "ng-in-viewport";


@NgModule({
    exports: [
        DefaultMasterPageComponent,
        TravelsPageComponent,
        TravelProfileComponent,
        EventsPageComponent,
        MainPageComponent,
        ChatPageComponent,
        LoginPageComponent,
        ForgotPasswordPageComponent,
        ChangePasswordPageComponent,
        UserProfileComponent,
    ],
    declarations: [
        DefaultMasterPageComponent,
        TravelsPageComponent,
        TravelProfileComponent,
        EventsPageComponent,
        MainPageComponent,
        ChatPageComponent,
        LoginPageComponent,
        ForgotPasswordPageComponent,
        ChangePasswordPageComponent,
        UserProfileComponent,
    ],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        HttpClientModule,
        UIRouterModule,
        ComponentsModule,
        PipesModule,
        ToastrModule.forRoot(),
        // CarouselModule
        InViewportModule,
    ],
    providers: [
        // {
        //   provide: ErrorHandler,
        //   useClass: GlobalErrorHandler
        // },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: AuthenticationInterceptor,
            multi: true,
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: ResponseInterceptor,
            multi: true,
        },

        TravelsService,
        EventsService,
        AuthenticationService,
        StorageService,
        SettingsService,
        RoutingService,
        AppToastrService,
        UsersService,
        ClientsService,
        WebsocketService,
        DictionaryService,
        DocumentsService,
        ChatService
    ]
})
export class PagesModule {
    constructor() {
    }
}
